<div class="email-confirmation container" appFadeIn>
  <h2>
    <i
      class="app-message__icon fa-solid"
      [ngClass]="{
        'fa-spinner fa-spin app-message__icon--loading': confirmationState === 'loading',
        'fa-circle-check app-message__icon--success': confirmationState === 'success',
        'fa-circle-exclamation app-message__icon--error': confirmationState === 'error'
      }"
      aria-hidden="true"
    ></i>
    <span [innerHTML]="confirmationTitle"></span>
  </h2>
  <p [innerHTML]="status"></p>
  
  <hr>
  <p class="footer-text">
    Juno Audit &copy; 2025
  </p>
</div>
